/**
 * reducers/training-engines.ts
 * desc: training engines
 * note: AI models training engines
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { TrainingEnginesAction } from '../actions/training-engines';
import type { TrainingEngineDto } from '../../types/api/training-engines';

export interface TrainingEnginesState {
    isLoading: {
        getTrainingEngine: boolean;
        getTrainingEngines: boolean;
    };
    // empty until the first engine arrives
    detail: Partial<TrainingEngineDto>;
    list: TrainingEngineDto[];
}

const INITIAL_STATE: TrainingEnginesState = {
    isLoading: {
        getTrainingEngine: false,
        getTrainingEngines: true,
    },
    detail: {},
    list: [],
};


function trainingEnginesReducer(state: TrainingEnginesState = INITIAL_STATE, action: TrainingEnginesAction): TrainingEnginesState {
    switch (action.type) {
        // GET Training Engine (Instance)
        case 'GET_TRAINING_ENGINE_ERROR':
            return _getTrainingEngineError(state);
        case 'GET_TRAINING_ENGINE_REQUEST':
            return _getTrainingEngineRequest(state);
        case 'GET_TRAINING_ENGINE_SUCCESS':
            return _getTrainingEngineSuccess(state, action.payload);

            // GET Training Engines (Collection)
        case 'GET_TRAINING_ENGINES_ERROR':
            return _getTrainingEnginesError(state);
        case 'GET_TRAINING_ENGINES_REQUEST':
            return _getTrainingEnginesRequest(state);
        case 'GET_TRAINING_ENGINES_SUCCESS':
            return _getTrainingEnginesSuccess(state, action.payload);

        default:
            return state;
    }
}



//*************************************************
//*****   GET Training Engine (Instance)   ********
//*************************************************
function _getTrainingEngineError(state: TrainingEnginesState): TrainingEnginesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingEngine: false,
        },
    };
}

function _getTrainingEngineRequest(state: TrainingEnginesState): TrainingEnginesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingEngine: true,
        },
    };
}

function _getTrainingEngineSuccess(state: TrainingEnginesState, payload: TrainingEngineDto): TrainingEnginesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingEngine: false,
        },
        detail: payload,
    };
}



//*************************************************
//*****   GET Training Engines (Collection)   *****
//*************************************************
function _getTrainingEnginesError(state: TrainingEnginesState): TrainingEnginesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingEngines: false,
        },
    };
}

function _getTrainingEnginesRequest(state: TrainingEnginesState): TrainingEnginesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingEngines: true,
        },
    };
}

function _getTrainingEnginesSuccess(state: TrainingEnginesState, payload: TrainingEngineDto[]): TrainingEnginesState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTrainingEngines: false,
        },
        list: payload,
    };
}


export default trainingEnginesReducer as Reducer<TrainingEnginesState>;
